export enum LoginResponseType {
  Success = 'Success',
  InvalidRefreshToken = 'InvalidRefreshToken',
  WrongPassword = 'WrongPassword',
  UserNotFound = 'UserNotFound',
  InvalidUserState = 'InvalidUserState',
  EmailNotConfirmed = 'EmailNotConfirmed'
}
